import React, { Fragment, useEffect, useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import CardItem from "./CardItem";
import "./style.scss";
import AddVacationsModal from "./AddSickModal";
import SickHistoryCardItem from "./SickHistoryCardItem";
import SickService from "../../../../services/HRM/SickService";
import SickHistoryService from "../../../../services/HRM/SickHistoryService";
import SickLeaveSettingsService from "../../../../services/HRM/SickLeaveSettingsService";
import { Translate } from "../../../Enums/Tranlate";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";

const Sick = () => {
	const tabs = ["sick_leave", "sick_requests", "sick_leaves"];
	const [data, setData] = useState([]);
	const [historyData, setHistoryData] = useState([]);
	const [modal, setModal] = useState(false);
	const [selectTab, setSelectTab] = useState("sick_leave");
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [historyLoading, setHistoryLoading] = useState(false);
	const [search, setSearch] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const sickService = new SickService();

	// ── Sick Leave Settings tab ──────────────────────────────
	const [sickSettings, setSickSettings] = useState({
		annualAllowanceDays: "",
		excessDeductionPercentage: "",
	});
	const [loadingSick, setLoadingSick] = useState(false);
	const [savingSick, setSavingSick] = useState(false);

	useEffect(() => {
		if (selectTab !== "sick_leaves") return;
		setLoadingSick(true);
		new SickLeaveSettingsService()
			.getSettings()
			.then((res) => {
				if (res?.status === 200) setSickSettings(res?.data?.data);
			})
			.finally(() => setLoadingSick(false));
	}, [selectTab]);

	const saveSickSettings = () => {
		setSavingSick(true);
		new SickLeaveSettingsService()
			.updateSettings({
				annualAllowanceDays: Number(sickSettings.annualAllowanceDays),
				excessDeductionPercentage: Number(
					sickSettings.excessDeductionPercentage,
				),
			})
			.then((res) => {
				if (res?.status === 200)
					toast.success(Translate[lang]?.updated_successfully);
			})
			.finally(() => setSavingSick(false));
	};
	// ────────────────────────────────────────────────────────

	useEffect(() => {
		if (selectTab !== "sick_requests") return;
		setHistoryLoading(true);
		new SickHistoryService()
			.getList()
			.then((res) => {
				if (res?.status === 200) {
					setHistoryData(res?.data?.data || res?.data || []);
				}
			})
			.finally(() => setHistoryLoading(false));
	}, [selectTab]);

	const handleStatusChange = (id, newStatus) => {
		setHistoryData((prev) =>
			prev.map((row) =>
				row.id === id
					? {
							...row,
							status: newStatus === "approve" ? "approved" : "rejected",
						}
					: row,
			),
		);
	};

	return (
		<Fragment>
			<Card className="mb-3">
				<Card.Body className="d-flex p-3 align-items-center justify-content-between">
					<div className="d-flex align-items-center">
						{tabs?.map((tab, index) => (
							<p
								key={index}
								className="mb-0 mx-3 cursor-pointer"
								style={{
									color: tab === selectTab ? "var(--primary)" : "#7E7E7E",
									borderBottom: tab === selectTab ? "2px solid" : "none",
								}}
								onClick={() => setSelectTab(tab)}>
								{Translate[lang][tab]}
							</p>
						))}
					</div>
					<Button
						variant="primary"
						className="me-2 h-75"
						onClick={() => {
							setItem({});
							setModal(true);
						}}>
						{Translate[lang]?.add} {Translate[lang]?.sick}
					</Button>
				</Card.Body>
			</Card>

			{selectTab === "sick_leave" && (
				<Row>
					<Col lg={12}>
						<Card>
							<Card.Body className={`${hasData === 0 && "text-center"}`}>
								{loading && (
									<div style={{ height: "300px" }}>
										<Loader />
									</div>
								)}
								{hasData === 1 && !loading && (
									<Table responsive>
										<thead>
											<tr className="text-center">
												<th>
													<strong>I.D</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.employee_name}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.company_email}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.department}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.departure_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.return_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.reason}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.number_of_days}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.attachments}</strong>
												</th>
											</tr>
										</thead>
										<tbody className="table-body">
											{data?.map((item, index) => (
												<CardItem
													index={index}
													key={index}
													item={item}
													setItem={setItem}
													setModal={setModal}
													setShouldUpdate={setShouldUpdate}
												/>
											))}
										</tbody>
									</Table>
								)}
								{hasData === 0 && <NoData />}
								<Pagination
									setData={setData}
									service={sickService}
									shouldUpdate={shouldUpdate}
									setHasData={setHasData}
									setLoading={setLoading}
									search={search}
								/>
							</Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			{selectTab === "sick_requests" && (
				<Row>
					<Col lg={12}>
						<Card>
							<Card.Body
								className={`${!historyLoading && historyData.length === 0 && "text-center"}`}>
								{historyLoading && (
									<div style={{ height: "300px" }}>
										<Loader />
									</div>
								)}
								{!historyLoading && historyData.length > 0 && (
									<Table responsive>
										<thead>
											<tr className="text-center">
												<th>
													<strong>I.D</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.employee_name}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.department}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.departure_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.return_day}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.reason}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.number_of_days}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.status || "Status"}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.attachments}</strong>
												</th>
												<th>
													<strong>{Translate[lang]?.actions}</strong>
												</th>
											</tr>
										</thead>
										<tbody className="table-body">
											{historyData.map((item, index) => (
												<SickHistoryCardItem
													index={index}
													key={item.id}
													item={item}
													onStatusChange={handleStatusChange}
												/>
											))}
										</tbody>
									</Table>
								)}
								{!historyLoading && historyData.length === 0 && <NoData />}
							</Card.Body>
						</Card>
					</Col>
				</Row>
			)}

			{selectTab === "sick_leaves" && (
				<Card>
					<Card.Body>
						{loadingSick ? (
							<div style={{ height: "200px" }}>
								<Loader />
							</div>
						) : (
							<>
								<Row className="mt-2">
									<Col md={4} className="mb-3">
										<label className="text-label">
											{Translate[lang]?.annual_allowance_days}
										</label>
										<input
											type="number"
											className="form-control"
											value={sickSettings.annualAllowanceDays ?? ""}
											min={0}
											onChange={(e) =>
												setSickSettings((p) => ({
													...p,
													annualAllowanceDays: e.target.value,
												}))
											}
										/>
									</Col>
									<Col md={4} className="mb-3">
										<label className="text-label">
											{Translate[lang]?.excess_deduction_percentage}
										</label>
										<input
											type="number"
											className="form-control"
											value={sickSettings.excessDeductionPercentage ?? ""}
											min={0}
											max={100}
											onChange={(e) =>
												setSickSettings((p) => ({
													...p,
													excessDeductionPercentage: e.target.value,
												}))
											}
										/>
									</Col>
								</Row>
								<Button
									variant="primary"
									onClick={saveSickSettings}
									disabled={savingSick}>
									{savingSick ? (
										<span className="spinner-border spinner-border-sm" />
									) : (
										Translate[lang]?.save
									)}
								</Button>
							</>
						)}
					</Card.Body>
				</Card>
			)}

			{modal && (
				<AddVacationsModal
					modal={modal}
					item={item}
					setShouldUpdate={setShouldUpdate}
					setModal={() => setModal(false)}
				/>
			)}
		</Fragment>
	);
};

export default Sick;
